import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeWebMCPIfNeeded } from './components/WebMCP';
import { suppressLeonardoDeprecationWarnings } from './utils/leonardo/suppressDeprecationWarnings';
import { registerThirdPartyScripts } from './utils/initThirdPartyScripts';
import { getViteMetaEnv } from '@/utils/viteMetaEnv';
import './styles/main.scss';

registerThirdPartyScripts();
suppressLeonardoDeprecationWarnings();
initializeWebMCPIfNeeded();

// Import inert polyfill for browsers that don't support it natively
import 'wicg-inert';

// Development-only accessibility monitoring
if (getViteMetaEnv().DEV) {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 1000, {
      // Customize for colorscales.io focus areas - WCAG AA compliance
      rules: [
        { id: 'color-contrast', enabled: true }, // AA: 4.5:1 normal, 3:1 large (CRITICAL)
        { id: 'color-contrast-enhanced', enabled: false }, // AAA: 7:1 - intentionally disabled
        { id: 'focus-order-semantics', enabled: true },
        { id: 'landmark-one-main', enabled: true },
        { id: 'region', enabled: false }, // Disabled - would break advanced positioning
      ],
    });
  });
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
